import { endOfMonth, startOfMonth } from "date-fns";
import type { AppliedBucketState, ReservationsBucket } from "./reservationsTypes";

/**
 * Derives UI-ready state from a bucket's active block and bounds.
 */
export const deriveBucketState = (
  bucket: ReservationsBucket,
): AppliedBucketState => {
  const activeBlock = bucket.blocks.find(
    (block) => block.id === bucket.activeBlockId,
  );
  if (!activeBlock) {
    return {
      reservations: [],
      totalReservations: 0,
      reservationsStart: 0,
      reservationsEnd: -1,
      reachedPastEnd: false,
      reachedUpcomingEnd: false,
      fetchedMonthsRange: { from: null, until: null },
      reservationBounds: bucket.bounds,
    };
  }
  const { bounds } = bucket;
  const earliestMonth = bounds.earliestDate
    ? startOfMonth(bounds.earliestDate)
    : null;
  const latestMonth = bounds.latestDate ? startOfMonth(bounds.latestDate) : null;
  const hasBounds = bounds.resolved;
  const noReservations = hasBounds && !earliestMonth && !latestMonth;
  const reachedPast = noReservations
    ? true
    : hasBounds && earliestMonth
      ? activeBlock.from.getTime() <= earliestMonth.getTime()
      : false;
  const reachedUpcoming = noReservations
    ? true
    : hasBounds && latestMonth
      ? activeBlock.until.getTime() >= latestMonth.getTime()
      : false;
  return {
    reservations: activeBlock.reservations,
    totalReservations: activeBlock.totalReservations,
    reservationsStart: activeBlock.reservationsStart,
    reservationsEnd: activeBlock.reservationsEnd,
    reachedPastEnd: reachedPast,
    reachedUpcomingEnd: reachedUpcoming,
    fetchedMonthsRange: {
      from: activeBlock.from,
      until: endOfMonth(activeBlock.until),
    },
    reservationBounds: bucket.bounds,
  };
};
